export const FLAG_GETTING_LEGAL_MANIFEST_BAGGAGES = 'FLAG_GETTING_LEGAL_MANIFEST_BAGGAGES';
export const GET_LEGAL_MANIFEST_BAGGAGES = 'GET_LEGAL_MANIFEST_BAGGAGES';
export const CLEAR_LEGAL_MANIFEST_BAGGAGES = 'CLEAR_LEGAL_MANIFEST_BAGGAGES';